import { OwcModalDialog, OwcButton, OwcTypography,
         OwcComponentHeader, OwcComponentFooter, OwcProgressSpinner,
         OwcTable, OwcTableCell, OwcTableRow, OwcTableHeader, OwcTableHeaderCell,
         OwcTableBody} from '@one/react';
import DelayedTooltip from '../general/DelayedTooltip.js';
import React from 'react';
import '../../styles.scss';

import {configData} from "../../config.js";
import {formatDate, fetchSigned, isRecentMessage} from "../../shared/Utilities.js"

/**
 * Renders the device details screen
 *
 * @copyright Roche 2023
 * @author Nick Draper
 */
class DataProductUsage extends React.Component {
  /**
   * Constructor 
   * 
   * @param props The properties passed
   */
  constructor(props) {
    super(props);
    this.state = {
      useCaseId: props.useCaseId,
      dpUsageLoaded: false,
      dpUsage: [],
      limit: 100,
      visible: false,
    };
  }

  /** Runs whenever the properties of the control are changed
   * @param prevProps The previous properties dictionary
   * @param prevState The previous state dictionary
   */
  componentDidUpdate(prevProps, prevState) {
    const statechange = {};
    if (prevProps.useCaseId !== this.props.useCaseId) {
      if (this.props.useCaseId !== null) {
        statechange.useCaseId = this.props.useCaseId;
      }

    }
    if (this.props.showNow !== null && prevProps.showNow !== this.props.showNow && isRecentMessage(this.props.showNow)) {
      statechange.visible = true;
    }
    if (Object.keys(statechange).length > 0) {
      this.setState(statechange,  () => this.loadDPUsage(this.props.useCaseId));
    }
    
  }

  /**
   * Loads the identity data to display for a device
   * @param {*} useCaseId the device_id to load
   */
  loadDPUsage(useCaseId) {
    const submissionData = {name:"Data Uses with Devices",
                            limit: this.state.limit,
                            needed_parameters: [{dataUseId: useCaseId},
                                                {applicableDevices: ""}
                                              ]
                            };
    console.log("loading data product usage for ", useCaseId);
    console.log(JSON.stringify(submissionData));
    fetchSigned(configData.DATA_PRODUCT_URL + "/data/usage/",
                {method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(submissionData)})
    .then(res => res.json())
    .then(
      (result) => {
          console.log(result);
          this.setState({ dpUsage: result,  
                          dpUsageLoaded: true,
                          submissionState: ""});
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        this.setState({
          error
        });
      }
    )
  }



  /**
   * Renders the agreements table control
   * @returns The JSX of the controls
   */
  renderTable() {
    const error = this.state.error;
    const isLoaded = this.state.dpUsageLoaded;
    const items = this.state.dpUsage;

    if (error) {
      return <div style={{ paddingTop: "1em", paddingBottom: "3em" , color: "red", width:"100%"}}>Error: {error}</div>;
    } else if (items.length===0  && isLoaded === false){
      // if there is no data the table does not show the progress spinner correctly
      return (
        <div key={"DataProductUsageProgressSpinnerDiv"} 
            style={{display:"flex", flexDirection:"column", alignItems:"center", width:"100%"}}>
          <OwcProgressSpinner key={"DataProductUsageProgressSpinner"}></OwcProgressSpinner>
        </div>
      );
    } else {
      if (items.length===0  && isLoaded === true) {
        return <div style={{ paddingTop: "1em", paddingBottom: "3em", width:"100%"}}>No calls found</div>;
      }
      else {
        
        return (
          <OwcTable key={"DataProductUsageTable"} size='dense' elevated style={{width:"100%", height:"25rem"}}  
          cardProps={{style:{maxWidth:"100%"} }}>
            <OwcTableHeader sticky>
                <OwcTableHeaderCell key="titleCreationDate" resizable width="25%">Creation Date (UTC)</OwcTableHeaderCell>
                <OwcTableHeaderCell key="titleParameters" resizable width="50%">Parameters</OwcTableHeaderCell>
                <OwcTableHeaderCell key="titleRequestedBy" resizable width="25%">Requested By</OwcTableHeaderCell>
            </OwcTableHeader>
            <OwcTableBody loading={!isLoaded}>
              {items.map(item => this.renderTableRow(item))}
            </OwcTableBody>
            <OwcComponentHeader slot="header">
              Last {items.length<this.state.limit?items.length:this.state.limit} call{items.length!==1?"s":""}
            </OwcComponentHeader>
          </OwcTable>
        );
      }
    }
  }

  /**
   * Renders a for for a device
   * @param {*} item The device data
   * @returns The JSX of the controls
   */
  renderTableRow(item){
    const keyEnding = item.creationDate;
    let rowColour = configData.COLOUR_WHITE;

    return (
      <OwcTableRow
          key={"row" + keyEnding}
          id={"row" + keyEnding} 
          expandable 
          style={rowColour !== configData.COLOUR_WHITE? {backgroundColor: rowColour}: {}}
          ondblclick={(ev) => this.handleDetailsClick(ev, item.deviceId)}>
        <OwcTableCell 
            style={rowColour !== configData.COLOUR_WHITE? {backgroundColor: rowColour, whiteSpace:"nowrap"}: {whiteSpace:"nowrap"}} 
            key={"creationDateCell" + keyEnding} valign="middle">
          {formatDate(item.creationDate, true)}
        </OwcTableCell>
        <OwcTableCell style={rowColour !== configData.COLOUR_WHITE? {backgroundColor: rowColour, wordBreak:"normal"}: {wordBreak:"normal"}} 
            key={"parametersCell" + keyEnding} valign="middle">
          {item.creationParameters}
        </OwcTableCell>
        <OwcTableCell style={rowColour !== configData.COLOUR_WHITE? {backgroundColor: rowColour, wordBreak:"normal"}: {wordBreak:"normal"}} 
            key={"requestedByCell" + keyEnding} valign="middle">
          {item.requestedBy}
        </OwcTableCell>
      </OwcTableRow>
    );
  }


  /**
   * Renders the controls
   * @returns The JSX of the controls
   */
  render() {
    const modalStyle = { maxWidth: "100%", width:"100"};
    return (
      <OwcModalDialog 
          visible={this.state.visible}
          style={{maxWidth: "100%", width:"100%"}}
          size="large"
          cardProps={{ style: modalStyle }}
          disableBackdropClick={this.props.disableBackdropClick} 
          disableEscapeKeydown={this.props.disableEscapeKeydown} 
          disableScrollLock={this.props.disableScrollLock} 
          onVisibleChange={(ev)=>{
              if (ev.detail === false) 
                {this.setState({visible: false})};
            }}>
        <div style={{display:"flex", alignItems: "stretch", flexDirection:"column", marginLeft:"0.5em", marginRight:"0.5em", width:"calc(98% - 1em)",  maxWidth: '100%'}}>
          {this.props.useCaseId?
            <OwcTypography key={"DataProductUseIdLabel"}>For data use id = {this.props.useCaseId} and including "applicableDevices"</OwcTypography>
          :
            ""
          }
          {this.renderTable()}
        </div>

        <OwcComponentHeader slot="header">
          <OwcTypography style={{lineHeight:"0.2em"}} variant="title6">Data Use with Devices data product usage</OwcTypography>
        </OwcComponentHeader>
      
        <OwcComponentFooter slot="footer" style={{ display: 'flex', justifyContent: 'flex-end', padding:'30px 10px 10px 10px'}}>
          {this.props.closeButtonText
          ?(<div>
            <OwcButton style={{ marginLeft: "2em" }} 
                id={"DataProductUsageCloseBtn"} 
                flat
                onClick={(ev) => {this.setState({visible: false})}}>
              {this.props.closeButtonText}
            </OwcButton>
            {
              this.props.closeButtonTooltip
              ? <DelayedTooltip 
                    key={"DataProductUsageCloseBtnTooltip"} 
                    anchor={"DataProductUsageCloseBtn"}
                    placement="right"
                    offset={[-15,-200]}>
                  {this.props.closeButtonTooltip}
                </DelayedTooltip>
              : ""
            }
            </div>)
          : ""
          }
        </OwcComponentFooter>
      </OwcModalDialog>
    );

  }
}

DataProductUsage.defaultProps = {
  useCaseId: null,
  showNow: null,
  closeButtonText: "Close",
  closeButtonTooltip: "Close this overlay and return to the screen below",
  visible: true,
  disableBackdropClick: false,
  disableEscapeKeydown: false,
  disableScrollLock: false
}

export default DataProductUsage
